import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-x2" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-x2" }
const _hoisted_3 = { class: "w-2/3" }
const _hoisted_4 = { class: "mt-x4 flex items-center justify-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  type: "submit",
  class: "c-button c-button--basket w-auto"
}

import PostalCodeSuggest from '@/shared/address/ui/PostalCodeSuggest.vue';
import {
    BasketDeliveryAddress,
} from '@/storecontext/shared/api/server-apis';
import useCountries from '@/shared/address/useCountries';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import { useStepReset } from '@/storecontext/checkout/useStepReset';
import BasketDeliverableDialog from '@/storecontext/basket/ui/BasketDeliverableDialog.vue';
import { useRequiredForm } from '@/shared/form/useRequiredForm';
import { computed, watch } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import siteContextService from '@/storecontext/shared/site-context.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutChangeAddress',
  props: {
    isOpen: { type: Boolean, default: false },
    deliverableId: null,
    deliveryAddress: { default: undefined }
  },
  emits: ['close', 'change'],
  setup(__props: any, { emit }) {

const props = __props as { isOpen: boolean, deliverableId: number, deliveryAddress: BasketDeliveryAddress }




const labels = useBlockLabels();
const { setDeliveryAddress, invoiceAddress } = useCheckout();
const { siteCountryCode, siteCountryName, loaded } = useCountries();
const postalCodeValidationRegEx = computed<string>(() => siteContextService.country.postalCodeRegex);

const initialValues = () => {
    return {
        country: siteCountryName.value,
        firstName: props.deliveryAddress?.buyer?.firstName || invoiceAddress.value?.buyer?.firstName,
        lastName: props.deliveryAddress?.buyer?.lastName || invoiceAddress.value?.buyer?.lastName,
        street: props.deliveryAddress?.address?.street || invoiceAddress.value?.address?.street,
        street2: props.deliveryAddress?.address?.street2 || invoiceAddress.value?.address?.street2,
        hasLift: props.deliveryAddress?.address?.hasLift || invoiceAddress.value?.address?.hasLift,
        city: props.deliveryAddress?.address?.city || invoiceAddress.value?.address?.city,
        postalCode: props.deliveryAddress?.address?.postalCode || invoiceAddress.value?.address?.postalCode,
    };
};

const validationSchema = {
    firstName: 'required',
    lastName: 'required',
    city: 'required',
    street: 'required',
    postalCode: {
        postalCode: postalCodeValidationRegEx.value,
        required: true,
    },

};

const close = (): void => {
    emit('close');
};

const resetStep = useStepReset();

const { handleSubmit, setFieldValue, setValues } = useRequiredForm({
    validationSchema,
    initialValues: initialValues(),
});

// Wait for country names to be loaded
watch(loaded, (value) => {
    if (value) {
        setTimeout(() => {
            setFieldValue('country', siteCountryName.value);
        }, 100);
    }
}, { immediate: true });

watch(() => props.isOpen, (open) => {
    open && setValues(initialValues());
});

const submit = handleSubmit(async(form): Promise<void> => {
    const request: BasketDeliveryAddress = {
        address: {
            city: form.city,
            country: siteCountryName.value,
            countryCode: siteCountryCode.value,
            hasLift: form.hasLift,
            otherCountryName: '',
            postalCode: form.postalCode,
            unknownPostalCode: form.isUnknownPostalCode,
            street: form.street,
            street2: form.street2,
        },
        buyer: {
            companyName: '',
            firstName: form.firstName,
            lastName: form.lastName,
            vatNumber: '',
        },
    };

    await setDeliveryAddress(props.deliverableId, request);
    resetStep();
    close();
    emit('change');
});


return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")!

  return (_openBlock(), _createBlock(BasketDeliverableDialog, {
    "is-open": __props.isOpen,
    heading: _unref(labels).customerDeliveryShippingChangeAddressHeading,
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        id: "checkoutChangeAddress",
        name: "checkoutChangeAddress",
        class: "text-left mt-10",
        onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_InputText, {
            name: "firstName",
            label: _unref(labels).baseAddressFirstName
          }, null, 8, ["label"]),
          _createVNode(_component_InputText, {
            name: "lastName",
            label: _unref(labels).baseAddressLastName
          }, null, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_InputText, {
            name: "street",
            label: _unref(labels).baseAddressStreet
          }, null, 8, ["label"]),
          _createVNode(_component_InputText, {
            name: "street2",
            label: _unref(labels).baseAddressStreet2
          }, null, 8, ["label"])
        ]),
        _createVNode(_component_InputCheckbox, {
          name: "hasLift",
          class: "pb-x6 -mt-20",
          "show-errors": false,
          label: _unref(labels).baseAddressLift
        }, null, 8, ["label"]),
        _createVNode(PostalCodeSuggest),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_InputText, {
            name: "country",
            readonly: "",
            "input-clear": false,
            label: _unref(labels).baseAddressCountry
          }, null, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "c-magic-line c-magic-line--underline mr-32",
            onClick: _withModifiers(close, ["prevent"])
          }, _toDisplayString(_unref(labels).customerDeliveryShippingChangeAddressCancelButton), 9, _hoisted_5),
          _createElementVNode("button", _hoisted_6, _toDisplayString(_unref(labels).customerDeliveryShippingChangeAddressSubmitButton), 1)
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["is-open", "heading"]))
}
}

})